import React from 'react';
import { AppConfig } from '../config/appConfig';

const ClientSelector = ({ currentClientId, onClientChange }) => {
  // This could be fetched from an API
  const clients = [
    { id: 200, name: 'UPMC' },
    { id: 101, name: 'Sample Health System' },
    { id: 102, name: 'Demo Hospital' },
  ];
  
  return (
    <div className="flex items-center gap-2">
      <label className="text-sm font-medium text-gray-700">Client:</label>
      <select
        value={currentClientId}
        onChange={(e) => onClientChange(Number(e.target.value))}
        className="px-3 py-1 border border-gray-300 rounded-md shadow-sm focus:ring-[#18365E] focus:border-[#18365E]"
      >
        {clients.map(client => (
          <option key={client.id} value={client.id}>
            {client.name} (ID: {client.id})
          </option>
        ))}
      </select>
    </div>
  );
};

export default ClientSelector;